<template>
  <footer>
    <div class="copyright">
      <p>© {{ currentYear }}</p>
    </div>
    <MenuNavigation/>
  </footer>
</template>

<script setup>
import { useStore } from '@/KQL.js';
import { computed } from 'vue';

const kql = useStore();
const currentYear = new Date().getFullYear();
</script>

<style scoped>
@import '@/css/breakpoints.css';

  footer {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    max-width: var(--main-width-narrow);
    left: 0;
    right: 0;
    margin: auto;
    z-index: 2;
    padding-top: 5rem;
    padding-bottom: 8rem;
    margin-top: 20rem;
    box-sizing: border-box;
  }

  @media (--phone) {
    footer {
      padding-bottom: 38rem;
    }
  }

  .copyright {
    color: var(--gray);
    font-size: 0.9rem;
    width: 100%;
    text-align: center;
  }

  .copyright p {
    margin: 0;
  }
</style>
